import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const openWhatsApp = () => {
    window.open('https://wa.me/12244199922', '_blank');
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={openWhatsApp}
          className="fixed bottom-8 left-8 z-50 w-14 h-14 rounded-full hidden md:flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
          style={{
            backgroundColor: '#25D366'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#20BA5A';
            e.currentTarget.style.transform = 'scale(1.1) translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#25D366';
            e.currentTarget.style.transform = 'scale(1)';
          }}
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="w-7 h-7 text-white" fill="white" />
        </button>
      )}
    </>
  );
};

export default WhatsAppButton;
